var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { CompanyTemplateSearchContent } from "./CompanyTemplateSearchContent";
export class CompanyTemplateSearchResult {
  constructor(_data) {
    /**
     */
    __publicField(this, "Count");
    /**
     */
    __publicField(this, "TemplateSearchContents");
    /**
     * Adds support for polymorphism. The discriminator is the schema property
     * name that is used to differentiate between other schema that inherit this
     * schema.
     *
     * @protected
     * @type {string}
     * @memberof CompanyTemplateSearchResult
     */
    __publicField(this, "$type", "V1.DocumentTemplates.TemplateSearch.CompanyTemplateSearchResult");
    if (_data) {
      for (const property in _data) {
        if (_data.hasOwnProperty(property)) {
          this[property] = _data[property];
        }
      }
    }
  }
  /**
   * Initializes a new model instance.
   */
  init(_data) {
    if (_data) {
      this.Count = _data["Count"];
      if (_data["TemplateSearchContents"] && _data["TemplateSearchContents"].constructor === Array) {
        this.TemplateSearchContents = [];
        for (let item of _data["TemplateSearchContents"]) {
          const templateSearchContents_ = new CompanyTemplateSearchContent();
          this.TemplateSearchContents.push(templateSearchContents_.init(item));
        }
      }
    }
    return this;
  }
  toJSON(_data) {
    _data = typeof _data === "object" ? _data : {};
    _data["Count"] = this.Count;
    if (this.TemplateSearchContents && this.TemplateSearchContents.constructor === Array) {
      _data["TemplateSearchContents"] = [];
      for (let item of this.TemplateSearchContents) {
        _data["TemplateSearchContents"].push(item.toJSON());
      }
    }
    return _data;
  }
}
